import { BaseDto } from "./base.dto";
import { ProductDto } from "./product.dto";
import { SaleMediumDto } from "./saleMedium.dto";
import { VATRateDto } from "./vat-rate.dto";

export class ProductSaleMediumVatRateDto extends BaseDto {
    vatRateId: number;
    productId: number;
    saleMediumId: number;
    vatRate?: VATRateDto;
    product?: ProductDto;
    saleMedium?: SaleMediumDto;
}